import axios from '../index'

/**
 *  获取图形验证码
 * @param params
 * @returns {*}
 */
export function getImageVerifyCode(params) {
  return axios.post('/portal/verify/getImageVerifyCode', params)
}
